import React, {Component} from 'react';
import {StatusToggl} from "../StatusToggl";
import {Link} from "react-router-dom";

export class ClientRow extends Component {
    static action_activate = 'activate';
    static action_deactivate = 'deactivate';

    constructor(props) {
        super(props);
        this.handleClientStatusChange = this.handleClientStatusChange.bind(this);
        this.handleClientDelete = this.handleClientDelete.bind(this);
    }

    handleClientDelete() {
        this.props.onDelete(this.props.client.id)
    }

    handleClientStatusChange(shouldActivate) {
        const action = shouldActivate ? ClientRow.action_activate : ClientRow.action_deactivate;
        this.props.doClientStatusChange(this.props.client.id, action)
    }

    render() {
        return (
            <tr key={this.props.client.id}>
                <td><Link to={`/client/${this.props.client.id}/`}>{this.props.client.name}</Link></td>
                <td className="status-cell">
                    <StatusToggl onChange={this.handleClientStatusChange} active={this.props.client.active}
                                 onDelete={this.handleClientDelete}
                                 title={"Eliminar Cliente"}
                                 message={"Se eliminará el cliente"}
                                 question={"¿desea continuar?"}
                    />
                </td>
            </tr>
        )
    }
}
